import React from 'react';
import { Badge } from '@/components/ui/badge';

export const CompagnieStatsTab = ({ compagnieStats }) => (
  <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
    <table className="w-full text-sm">
      <thead><tr className="bg-slate-50 border-b">
        <th className="text-left px-4 py-2.5 text-xs font-semibold text-slate-600 uppercase">Compagnia</th>
        <th className="text-center px-3 py-2.5 text-xs font-semibold text-slate-600 uppercase">Totali</th>
        <th className="text-center px-3 py-2.5 text-xs font-semibold text-slate-600 uppercase">Erogate</th>
        <th className="text-center px-3 py-2.5 text-xs font-semibold text-slate-600 uppercase">Rifiutate</th>
        <th className="text-center px-3 py-2.5 text-xs font-semibold text-slate-600 uppercase">In Corso</th>
        <th className="text-center px-3 py-2.5 text-xs font-semibold text-slate-600 uppercase">Approvazione</th>
        <th className="text-right px-3 py-2.5 text-xs font-semibold text-slate-600 uppercase">Erogato</th>
        <th className="text-right px-3 py-2.5 text-xs font-semibold text-slate-600 uppercase">Provvigioni</th>
      </tr></thead>
      <tbody className="divide-y divide-slate-100">
        {compagnieStats.length === 0 ? (
          <tr><td colSpan="8" className="text-center py-8 text-slate-400">Nessuna statistica</td></tr>
        ) : compagnieStats.map(c => (
          <tr key={c.id || c.nome} className="hover:bg-slate-50/50" data-testid={`comp-stat-${c.id || c.nome}`}>
            <td className="px-4 py-2.5 font-medium text-slate-800">{c.nome}</td>
            <td className="px-3 py-2.5 text-center font-bold">{c.pratiche_totali}</td>
            <td className="px-3 py-2.5 text-center"><Badge className="bg-emerald-100 text-emerald-700 text-[10px]">{c.pratiche_erogate}</Badge></td>
            <td className="px-3 py-2.5 text-center"><Badge className="bg-red-100 text-red-700 text-[10px]">{c.pratiche_rifiutate}</Badge></td>
            <td className="px-3 py-2.5 text-center text-xs text-slate-500">{c.pratiche_in_corso}</td>
            <td className="px-3 py-2.5 text-center"><span className={`text-xs font-bold ${c.tasso_approvazione >= 70 ? 'text-green-600' : c.tasso_approvazione >= 40 ? 'text-amber-600' : 'text-red-600'}`}>{c.tasso_approvazione}%</span></td>
            <td className="px-3 py-2.5 text-right text-xs text-slate-600">{c.importo_totale_erogato ? `${c.importo_totale_erogato.toFixed(2)} EUR` : '-'}</td>
            <td className="px-3 py-2.5 text-right font-bold text-emerald-700">{c.provvigioni_totali ? `${c.provvigioni_totali.toFixed(2)} EUR` : '-'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
